<template>
  <div>
    <div class="supported">


    <router-link to="/" >supported by shengqi group</router-link>

    </div>
  </div>
</template>
<script>
export default {
  name: "transferComponent",

  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {

  }
};
</script>
<style scoped>
    .supported{   width: 100%;  background: #222133; text-align: center; color: #FFFFFF;}
        .supported a{ color: #FFFFFF;  }
</style>



// WEBPACK FOOTER //
// src/components/common/supported.vue